import { useEffect, useState } from "react";
import { MessageCircle, Instagram, Facebook, Music2, X } from "lucide-react";
import api from "@/lib/api";

export function ContactPopup() {
  const [cfg, setCfg] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    api.get("/public/platform").then((r) => setCfg(r.data?.popup)).catch(() => {});
  }, []);

  if (!cfg?.enabled) return null;

  const normUrl = (v, base, at = "") => {
    const s = String(v).trim();
    if (/^https?:\/\//i.test(s)) return s;
    const handle = s.replace(/^@/, "").replace(/\/+$/, "");
    return `https://${base}/${at}${handle}`;
  };

  const WA_MSG = encodeURIComponent("Halo Admin 👋\nSaya tertarik dengan KasPintar by EduNexa dan ingin mengetahui lebih lanjut mengenai fitur, harga, serta cara penggunaannya.\nMohon informasi selengkapnya. Terima kasih 🙏");

  const links = [
    cfg.whatsapp && { icon: MessageCircle, url: `https://wa.me/${String(cfg.whatsapp).replace(/\D/g, "")}?text=${WA_MSG}`, label: "WhatsApp", testid: "popup-whatsapp", cls: "bg-[#25D366]" },
    cfg.instagram && { icon: Instagram, url: normUrl(cfg.instagram, "instagram.com"), label: "Instagram", testid: "popup-instagram", cls: "bg-[#E1306C]" },
    cfg.facebook && { icon: Facebook, url: normUrl(cfg.facebook, "facebook.com"), label: "Facebook", testid: "popup-facebook", cls: "bg-[#1877F2]" },
    cfg.tiktok && { icon: Music2, url: normUrl(cfg.tiktok, "tiktok.com", "@"), label: "TikTok", testid: "popup-tiktok", cls: "bg-slate-900" },
  ].filter(Boolean);

  if (!links.length) return null;

  return (
    <div className="fixed bottom-5 right-5 z-50 flex flex-col items-end gap-2" data-testid="contact-popup">
      {open && links.map((l, i) => (
        <a key={l.testid} href={l.url} target="_blank" rel="noreferrer" data-testid={l.testid}
           style={{ transitionDelay: `${i * 30}ms` }}
           className={`flex items-center gap-2 rounded-full ${l.cls} py-2.5 pl-3.5 pr-4 text-sm font-medium text-white shadow-lg transition-all duration-200 hover:-translate-y-0.5 hover:shadow-xl`}>
          <l.icon className="h-4 w-4" strokeWidth={1.5} /> {l.label}
        </a>
      ))}
      <button onClick={() => setOpen(!open)} data-testid="contact-popup-toggle" aria-label="Kontak kami"
              className="flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_8px_30px_rgb(37,211,102,0.4)] transition-transform duration-150 hover:scale-105 active:scale-95">
        {open ? <X className="h-6 w-6" strokeWidth={1.5} /> : <MessageCircle className="h-6 w-6" strokeWidth={1.5} />}
      </button>
    </div>
  );
}
